import React, { useState } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

export default function Header({ changeLang }) {
  const { t, i18n } = useTranslation();
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <header className="header">
      <button className="menu-toggle" onClick={() => setMenuOpen(!menuOpen)}>
        <span className="hamburger-icon">☰</span>
      </button>
      
      <Link to="/" className="logo">
        <img src="/logo.png" alt="logo" className="logo-img" />
        <span className="logo-text">{t("header.companyName")}</span>
      </Link>
      
      <button className="lang-toggle" onClick={() => changeLang(i18n.language === "en" ? "ar" : "en")}>
        {i18n.language === "en" ? "العربية" : "English"}
      </button>
      
      <nav className={`nav-menu ${menuOpen ? "open" : ""}`}>
        <button className="close-menu" onClick={() => setMenuOpen(false)}>×</button>
        <Link to="/" onClick={() => setMenuOpen(false)}>{t("header.home")}</Link>
        <Link to="/about" onClick={() => setMenuOpen(false)}>{t("header.about")}</Link>
        <Link to="/contact" onClick={() => setMenuOpen(false)}>{t("header.contact")}</Link>
      </nav>
      
      {menuOpen && <div className="overlay" onClick={() => setMenuOpen(false)}></div>}
    </header>
  );
}
